import moment from 'moment';
import DTO from './DTO';
import IndividualEntrepreneurDTO from './IndividualEntrepreneurDTO';
import JuridicalDTO from './JuridicalDTO';

class SZLTDTO extends DTO {
  constructor(params, isValidInit) {
    const ipAttr = new IndividualEntrepreneurDTO().getAttributes();
    const legalAttr = new JuridicalDTO().getAttributes();
    const attributes = [
      {
        name: 'view_mode',
        type: String,
        validators: {},
        labelKey: 'view_mode',
      },
      {
        name: 'id',
        type: String,
        validators: {},
        labelKey: 'id',
      },
      ...ipAttr,
      ...legalAttr,
      {
        name: 'legal_entity_type',
        type: Number,
        validators: {},
        labelKey: 'legal_entity_type',
      },
      {
        name: 'number',
        type: String,
        validators: {},
        labelKey: 'registry.number',
      },
      {
        name: 'effective_date',
        type: String,
        validators: {},
        labelKey: 'effective_date',
      },
      {
        name: 'expiration_date',
        type: String,
        validators: {},
        labelKey: 'expiration_date',
      },
      {
        name: 'office_phone',
        type: String,
        validators: {},
        labelKey: 'office_phone',
      },
      {
        name: 'office_email',
        type: String,
        validators: {},
        labelKey: 'office_email',
      },
      {
        name: 'database_address',
        type: String,
        validators: {},
        labelKey: 'database_address',
      },
      {
        name: 'server_address',
        type: String,
        validators: {},
        labelKey: 'server_address',
      },
      {
        name: 'software_names',
        type: String,
        validators: {},
        labelKey: 'software_names',
      },
      {
        name: 'web_site',
        type: String,
        validators: {},
        labelKey: 'web_site',
      },
      {
        name: 'commercial_name',
        type: String,
        validators: {},
        labelKey: 'commercial_name',
      },
      {
        name: 'order_receiving_methods',
        type: String,
        validators: {},
        labelKey: 'order_receiving_methods',
      },
      {
        name: 'logo_files',
        type: String,
        validators: {},
        labelKey: 'logo_files',
      },
      {
        name: 'status',
        type: String,
        validators: {},
        labelKey: 'status',
      },
      {
        name: 'created_at',
        type: moment,
        validators: {},
        labelKey: 'created_at',
      },
      {
        name: 'decision',
        type: String,
        validators: {},
        labelKey: 'decision',
      },
      {
        name: 'decision_date',
        type: String,
        validators: {},
        labelKey: 'decision_date',
      },
      {
        name: 'office_address',
        type: String,
        validators: {},
        labelKey: 'office_address',
      },
      {
        name: 'order_receiving_methods_change_document',
        type: String,
        validators: {},
        labelKey: 'media.order_receiving_methods_change_document',
      },
      {
        name: 'web_site_change_document',
        type: String,
        validators: {},
        labelKey: 'media.web_site_change_document',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    const ipData = new IndividualEntrepreneurDTO().getData.call(this);
    const legalData = new JuridicalDTO().getData.call(this);
    return {
      ...ipData,
      ...legalData,
      id: this.id,
      legal_entity_type: this.legal_entity_type,
      number: this.number,
      effective_date: this.effective_date,
      office_phone: this.office_phone,
      office_email: this.office_email,
      database_address: this.database_address,
      software_names: this.software_names,
      web_site: this.web_site,
      commercial_name: this.commercial_name,
      order_receiving_methods: this.order_receiving_methods,
      logo_files: this.logo_files,
      status: this.status,
      created_at: this.created_at,
    };
  }
}

export default SZLTDTO;
